
import api from "../../../../api/api"

const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}

const getAttendanceByDate = (selectedDate) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/attendance/date?selectedDate="+selectedDate).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getAttendanceByEmployee = (employeeId,filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/attendance/employee/"+employeeId+"?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const getLeaveRequestListAll = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/leave-request/all?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getLeaveRequestListByEmployee = (employeeId,filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/leave-request/employee/"+employeeId+"?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getWorkReportListAll = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/work-report/all?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getWorkReportListByEmployee = (employeeId,filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/work-report/employee/"+employeeId+"?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const updateLeaveRequest = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/leave-request/update",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const updatePunch = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/attendance/update",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const attendanceServices = {
    getAttendanceByDate,
    getAttendanceByEmployee,
    getLeaveRequestListAll,
    getLeaveRequestListByEmployee,
    getWorkReportListAll,
    getWorkReportListByEmployee,

    updateLeaveRequest,
    updatePunch,
    
}
export default attendanceServices;